/* IMPORT */
import untrack from './untrack.js';
/* MAIN */
// This function ensures an Observable contains a fresh value, mainly to try to push it into a frozen state, if possible
const warmup = (value) => {
    untrack(value);
    return value;
};
/* EXPORT */
export default warmup;
